import { Link } from 'react-router';
import { ArticleCard } from '../components/ArticleCard';
import { WorksList } from '../components/WorksList';
import type { Category, Child } from '../types/articles';

/**
 * 子要素のトップページ (/<category>/<child>)。説明文と、所属する
 * 既存コンテンツ (記事一覧または Bourbaki 解答一覧) を表示する。
 */
export function ChildPage({ category, child }: { category: Category; child: Child }) {
  return (
    <>
      <div className="hero">
        <p className="article-breadcrumb">
          <Link to={`/${category.key}`}>{category.title}</Link>
        </p>
        <h1>{child.title}</h1>
      </div>
      <section className="card">
        {child.description.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
        {child.kind === 'solutions' && <WorksList />}
        {!child.groups?.length && child.articles.length > 0 && (
          <div className="article-grid">
            {child.articles.map((article) => (
              <ArticleCard article={article} key={article.slug} />
            ))}
          </div>
        )}
      </section>
      {child.groups?.map((group) => {
        const inGroup = child.articles.filter((a) => a.group === group.key);
        return (
          <section className="card" key={group.key}>
            <h2>{group.title}</h2>
            {group.description.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
            {inGroup.length > 0 && (
              <div className="article-grid">
                {inGroup.map((article) => (
                  <ArticleCard article={article} key={article.slug} />
                ))}
              </div>
            )}
          </section>
        );
      })}
      <nav className="card" aria-label={`${category.title}の他のページ`}>
        <h2>
          <Link to={`/${category.key}`}>{category.title}</Link>の他のページ
        </h2>
        <ul className="content-links">
          {category.children.map((sibling) =>
            sibling.key === child.key ? (
              <li key={sibling.key}>
                <span className="current" aria-current="page">
                  {sibling.title}
                </span>
              </li>
            ) : (
              <li key={sibling.key}>
                <Link to={`/${category.key}/${sibling.key}`}>{sibling.title}</Link>
              </li>
            ),
          )}
        </ul>
      </nav>
    </>
  );
}
